<template>
  <SogForm ref="_form">
    <SogFormField>
      <SogTextBox
        v-model="_password"
        placeholder="Password eingeben"
        type="password"
      />
    </SogFormField>
    <SogFormField>
      <SogTextBox
        v-model="_passwordRepeat"
        placeholder="Password wiederholen"
        type="password"
      />
    </SogFormField>
  </SogForm>
</template>

<script setup lang="ts">
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import {ref} from "vue";
import notificationService from "@/shared/services/NotificationService";
const _password = ref("");
const _passwordRepeat = ref("");
//const _data = ref({userName: "im a test"});
const _form = ref<InstanceType<typeof SogForm>  | null>(null)


function validate():boolean {
  if (_password.value.length === 0) {
    notificationService.error("Passwort darf nicht leer sein")
    return false
  }
  if (_password.value !== _passwordRepeat.value) {
   notificationService.error("Passwörter stimmen nicht überein")
    return false
  }
  return _form.value?.validate() ?? false;
}

function getPassword():string|undefined{
  if (_password.value === _passwordRepeat.value) {
    return _password.value;
  }
  return undefined;
}

defineExpose({
  getPassword,validate
})

</script>

<style scoped>

</style>